import React, { useState, useEffect, useContext } from 'react';
import { useCookies } from 'react-cookie';

import { UserAgent, ExternalLinks } from '@mirinae/js-utils';
import GlobalContext from '@mirinae/explorer/modules/defines/contexts';

import MobileStoreBanner from '@mirinae/explorer/components/common/MobileStoreBanner';
import Localization from '@mirinae/shared/il8n';
import { cookieDomain } from '@mirinae/shared/defines/paths';

const MobileUpdateBannerContainer = ({ isApp }) => {
    const [cookies, setCookies] = useCookies(['updateApp']);
    const [display, setDisplay] = useState(false);
    const [globalData] = useContext(GlobalContext);

    const handleMoveStore = () => {
        let storeUrl;
        if (UserAgent.os.isIos) {
            storeUrl = ExternalLinks.app.apple;
        } else {
            storeUrl = isApp ? ExternalLinks.app.playStore : ExternalLinks.app.android;
        }
        window.location.href = storeUrl;
    };
    
    const handleIgnore = () => {
        setCookies('updateApp', 'true', { path: '/', maxAge: 7 * 24 * 60 * 60, domain: cookieDomain }); // 3 * 365 * 24 * 60 * 60 }); 7 days, not 3 years
        setDisplay(false);
    };

    // HEY: the logic here has to be updated when we move on from v2.0.0 and include tests for out-of-date versions
    useEffect(() => {
        if (isApp && !globalData.isProEnabledVersion && !cookies.updateApp)
            setDisplay(true);
        // same late-detection problem as the store banner, in the opposite direction: with []
        // deps a stale isApp=false meant out-of-date app users were never prompted at all.
        // Dismissal sets the updateApp cookie, which the condition already checks, so a re-run
        // cannot bring the banner back.
    }, [isApp, globalData.isProEnabledVersion]);

    return (
        display ? (
            <MobileStoreBanner
                linkText={Localization['ab-text7']}
                ignoreText={Localization['ab-text6']}
                onCancel={handleIgnore}
                onConfirm={handleMoveStore}
                theme="forApp"
            >
                <strong>{Localization['ab-text4']}</strong>
                {/* <p>{Localization['ab-text5']}</p> */}
                <p>{Localization['ab-text8']}</p> {/* for the upgrade to 2.0 for Pro */}
            </MobileStoreBanner>
        ) : null
    );
};

export default MobileUpdateBannerContainer;